export enum DataType {
    Date = 'date',
    DateBold = 'dateBold',
    Number = 'number',
    NumberBold = 'numberBold',
    Icon = 'icon',
    Growth = 'growth',
    TitleWithIcon = 'titleWithIcon',
    TextBold = 'textBold',
    Text = 'text',
    Currency = 'currency',
    CurrencyBold = 'currencyBold',
    Percentage = 'percentage',
    PercentageBold = 'percentageBold',
    PercentageCompleted = 'percentageCompleted',
}
